import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { withSlider } from '../../context/SliderContext';

import Image from '../image';
import Close from '../icons/close';

import RecipeIngredients from './ingredients/';
import RecipeSteps from './steps/';

import './recipe.css';

type Props = {
  recipe: Recipe;
  setSlide: (slide: number) => {};
};

SwiperCore.use([Navigation]);

const Recipe = ({ recipe, setSlide }: Props) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    setSlide(parseInt(recipe.pid, 10) - 1);
  }, [recipe]);

  return (
    <div className={`recipe-wrapper ${recipe.rid}`}>
      <RecipeSteps current={step} length={recipe.steps.length + 1} />
      <Link className="recipe-back-link" to="/" title="Retour a l'accueil">
        <Close fill={recipe.style.fill} stroke={recipe.style.stroke} />
      </Link>
      <Swiper
        id="recipe"
        navigation
        slidesPerView={1}
        onSlideChange={event => setStep(event.activeIndex)}
      >
        <SwiperSlide>
          <RecipeIngredients
            pid={recipe.pid}
            informations={recipe.information}
            ingredients={recipe.ingredients}
          />
        </SwiperSlide>
        {recipe.steps.map((step, index) => (
          <SwiperSlide key={index}>
            <Image
              alt={`Étape ${index + 1}`}
              className={`recipe-image recipe-step-${index}`}
              path={`${recipe.pid}-step-${index + 1}.jpg`}
            />
            <div className="recipe-text">
              <h3>
                {index + 1}.{step.title}
              </h3>
              <p>{step.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default withSlider(Recipe);
